<div class="ai-chat">
  <!-- Floating action button -->
  <button
    type="button"
    class="ai-chat-bubble"
    [class.ai-chat-bubble--hidden]="isOpen"
    (click)="toggleChat()"
    aria-label="Abrir chat de ayuda"
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="ai-chat-bubble-icon">
      <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12z"/>
      <path d="M7 9h10v2H7zm0-3h10v2H7z"/>
    </svg>
  </button>

  <!-- Chat panel -->
  <div
    class="ai-chat-panel"
    *ngIf="isOpen"
    [style.width.px]="panelWidth"
  >
    <!-- Resize handle -->
    <div
      class="ai-chat-resize-handle"
      (mousedown)="onResizeStart($event)"
      title="Arrastrar para redimensionar"
    ></div>

    <div class="ai-chat-header">
      <div class="ai-chat-header-info">
        <div class="ai-chat-avatar">
           <i class="fas fa-robot"></i>
        </div>
        <div class="ai-chat-header-titles">
          <div class="ai-chat-header-title">Asistente Civitrans</div>
          <div class="ai-chat-header-subtitle">Consultas y reportes</div>
        </div>
      </div>
      <div class="ai-chat-actions">
        <button
          type="button"
          class="ai-chat-action-btn"
          (click)="clearHistory()"
          title="Borrar conversación"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="ai-chat-action-icon">
            <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
          </svg>
        </button>
        <button
          type="button"
          class="ai-chat-action-btn"
          (click)="toggleChat()"
          title="Cerrar"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="ai-chat-action-icon">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
          </svg>
        </button>
      </div>
    </div>

    <div class="ai-chat-messages" #messagesContainer>
      <div class="ai-chat-welcome" *ngIf="showWelcome">
        <div class="ai-chat-welcome-text">Hola, ¿qué necesitas consultar?</div>
        <div class="ai-chat-welcome-subtext">Puedes buscar comparendos, consultar estadísticas o solicitar reportes.</div>
        <div class="ai-chat-welcome-cards">
          <div class="ai-chat-welcome-card">
            <div class="ai-chat-welcome-card-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
              </svg>
            </div>
            <div class="ai-chat-welcome-card-content">
              <div class="ai-chat-welcome-card-title">Consultar una placa</div>
              <div class="ai-chat-welcome-card-subtitle">Busca comparendos por placa</div>
            </div>
          </div>
          <div class="ai-chat-welcome-card">
            <div class="ai-chat-welcome-card-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zm4 18H6V4h7v5h5z"/>
              </svg>
            </div>
            <div class="ai-chat-welcome-card-content">
              <div class="ai-chat-welcome-card-title">Crear un reporte</div>
              <div class="ai-chat-welcome-card-subtitle">Genera un informe personalizado</div>
            </div>
          </div>
          <div class="ai-chat-welcome-card">
            <div class="ai-chat-welcome-card-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/>
              </svg>
            </div>
            <div class="ai-chat-welcome-card-content">
              <div class="ai-chat-welcome-card-title">Estadísticas y métricas</div>
              <div class="ai-chat-welcome-card-subtitle">Visualiza datos y tendencias</div>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngFor="let message of messages; let i = index">
        <div
          *ngIf="!showWelcome || i > 0"
          class="ai-chat-message"
          [class.ai-chat-message-user]="message.role === 'user'"
          [class.ai-chat-message-model]="message.role === 'model'"
        >
          <div class="ai-chat-message-avatar" *ngIf="message.role === 'model'">
             <i class="fas fa-robot"></i>
          </div>
          <div class="ai-chat-message-wrapper">
            <div
              class="ai-chat-message-content"
              [innerHTML]="message.content | markdown"
            ></div>
            <app-ai-chat-chart
              *ngIf="message.chartData"
              class="ai-chat-message-chart"
              [chartData]="message.chartData"
            ></app-ai-chat-chart>
            <app-ai-chat-options
              *ngIf="message.optionsData"
              class="ai-chat-message-options"
              [optionsData]="message.optionsData"
              (optionSelected)="onChartOptionSelected($event)"
            ></app-ai-chat-options>
            <app-ai-chat-download
              *ngIf="message.downloadData"
              class="ai-chat-message-download"
              [downloadData]="message.downloadData"
            ></app-ai-chat-download>
          </div>
        </div>
      </ng-container>

      <div class="ai-chat-loading" *ngIf="loading">
        <div class="ai-chat-loading-dot"></div>
        <div class="ai-chat-loading-dot"></div>
        <div class="ai-chat-loading-dot"></div>
      </div>

      <div class="ai-chat-error" *ngIf="error">
        {{ error }}
      </div>
    </div>

    <div class="ai-chat-footer">
      <input
        type="text"
        class="ai-chat-input"
        placeholder="Escribe tu consulta..."
        [(ngModel)]="inputText"
        (keydown)="onKeyDown($event)"
        [disabled]="loading"
      />
      <button
        type="button"
        class="ai-chat-send-btn"
        (click)="sendMessage()"
        [disabled]="!inputText.trim() || loading"
        aria-label="Enviar mensaje"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="ai-chat-send-icon">
          <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
        </svg>
      </button>
    </div>
  </div>
</div>
